// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ts3-section {
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.ts3-latest {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  min-width: 0;
  max-width: 8.5rem;
}

.ts3-latest__label {
  font-size: 0.74rem;
  color: #64748b;
}

.ts3-latest__value {
  min-width: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 0.86rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark .ts3-latest__label {
  color: #94a3b8;
}

.dark .ts3-latest__value {
  color: #f8fafc;
}

.ts3-traversal-body {
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: none;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0.65rem 0 1.1rem;
}

.ts3-traversal-body::-webkit-scrollbar {
  display: none;
}

.ts3-tree-list,
.ts3-tree-children {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ts3-tree-list {
  display: grid;
  gap: 0.62rem;
}

.ts3-tree-children {
  display: grid;
  gap: 0.5rem;
  margin-top: 0.5rem;
  margin-left: 1.05rem;
  padding-left: 0.82rem;
}

.ts3-tree-branch {
  position: relative;
}

.ts3-tree-list > .ts3-tree-branch::before {
  content: "";
  position: absolute;
  top: -0.62rem;
  bottom: -0.62rem;
  left: 1.05rem;
  border-left: 1px solid rgba(148, 163, 184, 0.55);
  z-index: 0;
}

.ts3-tree-list > .ts3-tree-branch:first-child::before {
  top: 0.94rem;
  bottom: -0.62rem;
}

.ts3-tree-list > .ts3-tree-branch:last-child::before {
  bottom: auto;
  height: calc(0.94rem + 0.62rem);
}

.ts3-tree-list > .ts3-tree-branch:first-child:last-child::before {
  display: none;
}

.ts3-tree-list > .ts3-tree-branch::after {
  content: none;
}

.ts3-tree-children > .ts3-tree-branch::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  bottom: -0.5rem;
  left: -0.82rem;
  border-left: 1px solid rgba(148, 163, 184, 0.55);
}

.ts3-tree-children > .ts3-tree-branch:last-child::before {
  bottom: auto;
  height: calc(0.94rem + 0.5rem);
}

.ts3-tree-children > .ts3-tree-branch::after {
  content: "";
  position: absolute;
  top: 0.94rem;
  left: -0.82rem;
  width: 0.82rem;
  border-top: 1px solid rgba(148, 163, 184, 0.55);
}

.dark .ts3-tree-children > .ts3-tree-branch::before {
  border-left-color: rgba(71, 85, 105, 0.8);
}

.dark .ts3-tree-list > .ts3-tree-branch::before {
  border-left-color: rgba(71, 85, 105, 0.8);
}

.dark .ts3-tree-list > .ts3-tree-branch::after {
  border-top-color: rgba(71, 85, 105, 0.8);
}

.dark .ts3-tree-children > .ts3-tree-branch::after {
  border-top-color: rgba(71, 85, 105, 0.8);
}

.ts3-tree-node {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 0.38rem;
  padding: 0.34rem 0.46rem;
  border: 1px solid rgba(203, 213, 225, 0.85);
  border-radius: 6px;
  background: rgba(248, 250, 252, 0.96);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.05);
}

.dark .ts3-tree-node {
  border-color: rgba(71, 85, 105, 0.9);
  background: rgba(30, 41, 59, 0.9);
  box-shadow: 0 1px 3px rgba(2, 6, 23, 0.22);
}

.ts3-tree-node--clickable {
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ts3-tree-node--clickable:hover {
  border-color: rgba(8, 145, 178, 0.45);
  box-shadow:
    0 0 0 2px rgba(8, 145, 178, 0.12),
    0 1px 2px rgba(15, 23, 42, 0.05);
}

.dark .ts3-tree-node--clickable:hover {
  border-color: rgba(45, 212, 191, 0.4);
  box-shadow:
    0 0 0 2px rgba(45, 212, 191, 0.1),
    0 1px 3px rgba(2, 6, 23, 0.22);
}

.ts3-tree-node--faded {
  opacity: 0.38;
  filter: saturate(0.55);
  transition: opacity 0.2s ease;
}

.ts3-tree-node--faded.ts3-tree-node--clickable:hover {
  opacity: 0.75;
}

.ts3-tree-branch--faded::before,
.ts3-tree-branch--faded::after {
  opacity: 0.35;
}

.ts3-tree-node.active {
  border-color: rgba(14, 116, 144, 0.42);
  background: rgba(236, 254, 255, 0.97);
  box-shadow:
    0 0 0 2px rgba(8, 145, 178, 0.1),
    0 1px 2px rgba(8, 145, 178, 0.08);
}

.dark .ts3-tree-node.active {
  border-color: rgba(45, 212, 191, 0.35);
  background: rgba(18, 74, 69, 0.34);
  box-shadow:
    0 0 0 2px rgba(45, 212, 191, 0.08),
    0 1px 2px rgba(2, 6, 23, 0.24);
}

.ts3-tree-level {
  flex: 0 0 auto;
  padding: 0.12rem 0.34rem;
  border-radius: 999px;
  background: rgba(226, 232, 240, 0.95);
  color: #475569;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
}

.dark .ts3-tree-level {
  background: rgba(51, 65, 85, 0.92);
  color: #cbd5e1;
}

.ts3-tree-value {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #0f172a;
  font-size: 0.74rem;
  font-weight: 800;
  line-height: 1.2;
}

.dark .ts3-tree-value {
  color: #e2e8f0;
}

.ts3-tree-value--task {
  color: #c2410c;
}

.ts3-tree-value--stage {
  color: #1d4ed8;
}

.ts3-tree-value--strategy {
  color: #92400e;
}

.ts3-tree-value--skill {
  color: #7e22ce;
}

.dark .ts3-tree-value--task {
  color: #fb923c;
}

.dark .ts3-tree-value--stage {
  color: #93c5fd;
}

.dark .ts3-tree-value--strategy {
  color: #facc15;
}

.dark .ts3-tree-value--skill {
  color: #d8b4fe;
}

.ts3-tree-turn {
  color: #64748b;
  font-size: 0.62rem;
  font-weight: 750;
  white-space: nowrap;
}

.dark .ts3-tree-turn {
  color: #94a3b8;
}

.ts3-empty-state {
  height: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
  text-align: center;
  color: #64748b;
  font-size: 0.84rem;
}

.dark .ts3-empty-state {
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/Ts3TraversalPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC;oCACkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC;;oCAEkC;AACpC;;AAEA;EACE,qCAAqC;EACrC;;kCAEgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC;;qCAEmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC;;kCAEgC;AAClC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ts3-section {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  margin-bottom: 1rem;\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.ts3-latest {\n  display: flex;\n  align-items: baseline;\n  gap: 0.35rem;\n  min-width: 0;\n  max-width: 8.5rem;\n}\n\n.ts3-latest__label {\n  font-size: 0.74rem;\n  color: #64748b;\n}\n\n.ts3-latest__value {\n  min-width: 0;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 0.86rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dark .ts3-latest__label {\n  color: #94a3b8;\n}\n\n.dark .ts3-latest__value {\n  color: #f8fafc;\n}\n\n.ts3-traversal-body {\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  max-height: none;\n  overflow: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 0.65rem 0 1.1rem;\n}\n\n.ts3-traversal-body::-webkit-scrollbar {\n  display: none;\n}\n\n.ts3-tree-list,\n.ts3-tree-children {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ts3-tree-list {\n  display: grid;\n  gap: 0.62rem;\n}\n\n.ts3-tree-children {\n  display: grid;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  margin-left: 1.05rem;\n  padding-left: 0.82rem;\n}\n\n.ts3-tree-branch {\n  position: relative;\n}\n\n.ts3-tree-list > .ts3-tree-branch::before {\n  content: \"\";\n  position: absolute;\n  top: -0.62rem;\n  bottom: -0.62rem;\n  left: 1.05rem;\n  border-left: 1px solid rgba(148, 163, 184, 0.55);\n  z-index: 0;\n}\n\n.ts3-tree-list > .ts3-tree-branch:first-child::before {\n  top: 0.94rem;\n  bottom: -0.62rem;\n}\n\n.ts3-tree-list > .ts3-tree-branch:last-child::before {\n  bottom: auto;\n  height: calc(0.94rem + 0.62rem);\n}\n\n.ts3-tree-list > .ts3-tree-branch:first-child:last-child::before {\n  display: none;\n}\n\n.ts3-tree-list > .ts3-tree-branch::after {\n  content: none;\n}\n\n.ts3-tree-children > .ts3-tree-branch::before {\n  content: \"\";\n  position: absolute;\n  top: -0.5rem;\n  bottom: -0.5rem;\n  left: -0.82rem;\n  border-left: 1px solid rgba(148, 163, 184, 0.55);\n}\n\n.ts3-tree-children > .ts3-tree-branch:last-child::before {\n  bottom: auto;\n  height: calc(0.94rem + 0.5rem);\n}\n\n.ts3-tree-children > .ts3-tree-branch::after {\n  content: \"\";\n  position: absolute;\n  top: 0.94rem;\n  left: -0.82rem;\n  width: 0.82rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.55);\n}\n\n.dark .ts3-tree-children > .ts3-tree-branch::before {\n  border-left-color: rgba(71, 85, 105, 0.8);\n}\n\n.dark .ts3-tree-list > .ts3-tree-branch::before {\n  border-left-color: rgba(71, 85, 105, 0.8);\n}\n\n.dark .ts3-tree-list > .ts3-tree-branch::after {\n  border-top-color: rgba(71, 85, 105, 0.8);\n}\n\n.dark .ts3-tree-children > .ts3-tree-branch::after {\n  border-top-color: rgba(71, 85, 105, 0.8);\n}\n\n.ts3-tree-node {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  gap: 0.38rem;\n  padding: 0.34rem 0.46rem;\n  border: 1px solid rgba(203, 213, 225, 0.85);\n  border-radius: 6px;\n  background: rgba(248, 250, 252, 0.96);\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.dark .ts3-tree-node {\n  border-color: rgba(71, 85, 105, 0.9);\n  background: rgba(30, 41, 59, 0.9);\n  box-shadow: 0 1px 3px rgba(2, 6, 23, 0.22);\n}\n\n.ts3-tree-node--clickable {\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.ts3-tree-node--clickable:hover {\n  border-color: rgba(8, 145, 178, 0.45);\n  box-shadow:\n    0 0 0 2px rgba(8, 145, 178, 0.12),\n    0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.dark .ts3-tree-node--clickable:hover {\n  border-color: rgba(45, 212, 191, 0.4);\n  box-shadow:\n    0 0 0 2px rgba(45, 212, 191, 0.1),\n    0 1px 3px rgba(2, 6, 23, 0.22);\n}\n\n.ts3-tree-node--faded {\n  opacity: 0.38;\n  filter: saturate(0.55);\n  transition: opacity 0.2s ease;\n}\n\n.ts3-tree-node--faded.ts3-tree-node--clickable:hover {\n  opacity: 0.75;\n}\n\n.ts3-tree-branch--faded::before,\n.ts3-tree-branch--faded::after {\n  opacity: 0.35;\n}\n\n.ts3-tree-node.active {\n  border-color: rgba(14, 116, 144, 0.42);\n  background: rgba(236, 254, 255, 0.97);\n  box-shadow:\n    0 0 0 2px rgba(8, 145, 178, 0.1),\n    0 1px 2px rgba(8, 145, 178, 0.08);\n}\n\n.dark .ts3-tree-node.active {\n  border-color: rgba(45, 212, 191, 0.35);\n  background: rgba(18, 74, 69, 0.34);\n  box-shadow:\n    0 0 0 2px rgba(45, 212, 191, 0.08),\n    0 1px 2px rgba(2, 6, 23, 0.24);\n}\n\n.ts3-tree-level {\n  flex: 0 0 auto;\n  padding: 0.12rem 0.34rem;\n  border-radius: 999px;\n  background: rgba(226, 232, 240, 0.95);\n  color: #475569;\n  font-size: 0.62rem;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.dark .ts3-tree-level {\n  background: rgba(51, 65, 85, 0.92);\n  color: #cbd5e1;\n}\n\n.ts3-tree-value {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  color: #0f172a;\n  font-size: 0.74rem;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.dark .ts3-tree-value {\n  color: #e2e8f0;\n}\n\n.ts3-tree-value--task {\n  color: #c2410c;\n}\n\n.ts3-tree-value--stage {\n  color: #1d4ed8;\n}\n\n.ts3-tree-value--strategy {\n  color: #92400e;\n}\n\n.ts3-tree-value--skill {\n  color: #7e22ce;\n}\n\n.dark .ts3-tree-value--task {\n  color: #fb923c;\n}\n\n.dark .ts3-tree-value--stage {\n  color: #93c5fd;\n}\n\n.dark .ts3-tree-value--strategy {\n  color: #facc15;\n}\n\n.dark .ts3-tree-value--skill {\n  color: #d8b4fe;\n}\n\n.ts3-tree-turn {\n  color: #64748b;\n  font-size: 0.62rem;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.dark .ts3-tree-turn {\n  color: #94a3b8;\n}\n\n.ts3-empty-state {\n  height: 100%;\n  display: grid;\n  align-content: center;\n  justify-content: center;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.84rem;\n}\n\n.dark .ts3-empty-state {\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
